import React from 'react'
import moment from 'moment'
import { startCase } from 'lodash'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

import './eventPopup.css'

export const EventPopup = ({
  children,
  eventType,
  eventTime,
  callTimeOffset,
  description,
  section,
}) => {
  const eventTypeDisplay =
    eventType === 'playbook'
      ? `${startCase(section)} Item`
      : `${startCase(eventType)} ${eventType !== 'Coaching' ? 'Alert' : ''}`
  const eventTimeDisplay =
    eventTime !== undefined ? moment.utc(eventTime).local().format('h:mm A') : ''
  const callTimeOffsetDisplay =
    callTimeOffset !== undefined ? moment.utc(callTimeOffset * 1000).format('mm:ss') : ''

  const content = (
    <div data-testid="eventPopup" className="eventPopup">
      <div className="eventPopup__header">
        <div className="eventPopup__col-type" data-testid="eventTypeDisplay">
          {eventTypeDisplay}
        </div>
        <div className="eventPopup__col-time" data-testid="eventTimeDisplay">
          {eventTimeDisplay}
        </div>
        <div className="eventPopup__col-offset" data-testid="callTimeOffsetDisplay">
          {callTimeOffsetDisplay}
        </div>
      </div>
      <div className="eventPopup__content" data-testid="descriptionDisplay">
        {description}
      </div>
    </div>
  )

  return (
    <InteractiveTooltip theme="light" placement="top" content={content}>
      {children}
    </InteractiveTooltip>
  )
}
